/* eslint-disable camelcase */
import { useState } from 'react';
import {
  Box, DialogActions, Button, Stack, DialogContent, TextField,
} from '@mui/material';
import styled from '@emotion/styled';
import Divider from '@mui/material/Divider';

import { useModalStore } from 'common/hooks/useModals';
import { MdOutlineClose } from 'react-icons/md';
import { useChangeRegistration } from 'aircraft/hooks/useChangeRegistration';

const ChangeRegistrationHeader = styled.div`
    font-weight: bold;
    font-size: 24px;
    padding: 12px;
  `;

const ModalDivider = styled(Divider)`
`;

const ActionButton = styled(Button)`
    font-size: 10px;
`;

const ModalHeaderActionContainer = styled(Stack)`
  justify-content: space-between;
`;

const CloseButton = styled(Button)`
  font-size: 20px;
  color: black;
`;

const SubmitButton = styled(ActionButton)`
  width: 120px;
`;

function View({
  reg_n_number,
  newRegNumber,
  onNewRegNumberChange,
  onSubmit,
  handleClose,
  isSubmitDisabled,
}) {
  return (
    <form onSubmit={onSubmit}>
      <ModalHeaderActionContainer spacing={2} direction="row">
        <ChangeRegistrationHeader>
          Change Registration Number
        </ChangeRegistrationHeader>
        <CloseButton variant="text" onClick={handleClose}>
          <MdOutlineClose />
        </CloseButton>
      </ModalHeaderActionContainer>
      <ModalDivider component="div" />
      <DialogContent>
        <Stack spacing={3}>
          <TextField
            label="Registration Number"
            value={reg_n_number || ''}
            InputProps={{ readOnly: true }}
            fullWidth
          />
          <TextField
            label="New Registration Number"
            value={newRegNumber}
            onChange={(e) => onNewRegNumberChange(e.target.value.toUpperCase())}
            inputProps={{ maxLength: 10 }}
            autoFocus
            required
            fullWidth
          />
        </Stack>
      </DialogContent>
      <ModalDivider component="div" />
      <DialogActions sx={{ justifyContent: 'space-between' }}>
        <Box />
        <Stack spacing={2} direction="row">
          <ActionButton variant="text" onClick={handleClose}>
            Cancel
          </ActionButton>
          <SubmitButton variant="contained" color="primary" type="submit" disabled={isSubmitDisabled}>
            Save
          </SubmitButton>
        </Stack>
      </DialogActions>
    </form>
  );
}

function Model() {
  const [newRegNumber, setNewRegNumber] = useState('');
  const { mutation: doChangeRegistration } = useChangeRegistration();

  const {
    changeRegistration,
    setChangeRegistrationState,
  } = useModalStore();

  const {
    reg_n_number,
    company_id,
  } = changeRegistration;

  const isSubmitDisabled = !newRegNumber.trim();

  const onSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitDisabled) return;

    doChangeRegistration({
      reg_n_number,
      new_reg_n_number: newRegNumber.trim(),
      company_id,
    });
  };

  const handleClose = () => {
    setNewRegNumber('');
    setChangeRegistrationState(false);
  };

  const hookProps = {
    reg_n_number,
    newRegNumber,
    onNewRegNumberChange: setNewRegNumber,
    onSubmit,
    handleClose,
    isSubmitDisabled,
  };

  return (
    <View
      {...hookProps}
    />
  );
}

export default Model;
export { View };
